import { render, staticRenderFns } from "./BeastOrganizationsList.vue?vue&type=template&id=06171cf4&scoped=true"
import script from "./BeastOrganizationsList.vue?vue&type=script&lang=js"
export * from "./BeastOrganizationsList.vue?vue&type=script&lang=js"
import style0 from "./BeastOrganizationsList.vue?vue&type=style&index=0&id=06171cf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06171cf4",
  null
  
)

export default component.exports